import * as actions from './actions'
import { EventProps, ExternalValueProps, LogPointsPage, ValueProps } from './LogPointsPage'
import { ResourceType } from '@mulesoft/monitoring-center-components/lib/models/resource'
import { selectors as authSelectors } from '../../../lifecycle/auth';
import { AppState, Dispatch } from '../../../types'
import { connect } from 'react-redux'
import selectors from './selectors'

const mapStateToProps = (state: AppState, ownProps: ExternalValueProps): ValueProps => {
  return {
    ...ownProps,
    organizationId: authSelectors.getOrganizationId(state),
    environmentSelector: selectors.environmentSelector.getAll(state),
    resourceSelector: selectors.resourceSelector.getAll(state),
    versionSelector: selectors.versionSelector.getAll(state)
  }
}

const mapDispatchToProps = (dispatch: Dispatch): EventProps => ({
  environmentSelected: (environmentId: string) =>
    dispatch(actions.environmentSelected(environmentId)),
  resourceSelected: (resourceId: string, resourceType: ResourceType) =>
    dispatch(actions.resourceSelected(resourceId, resourceType)),
  versionSelected: (versionId: string) =>
    dispatch(actions.versionSelected(versionId)),
  onView: (props: ExternalValueProps) =>
    dispatch(actions.viewLogPoints(props)),
  load: (props: ExternalValueProps) =>
    dispatch(actions.load(props)),
  fetchConnectors: () =>
    dispatch(actions.fetchConnectorsIcons())
})

export default connect(mapStateToProps, mapDispatchToProps)(LogPointsPage)
